"use strict";

exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _icon = _interopRequireDefault(require("./../../../fonts/icon"));
var _reactstrap = require("reactstrap");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const LimitDropdown = ({
  onChange,
  values,
  value
}) => {
  return /*#__PURE__*/_react.default.createElement(_reactstrap.UncontrolledDropdown, {
    className: 'd-inline-block'
  }, /*#__PURE__*/_react.default.createElement(_reactstrap.DropdownToggle, {
    caret: true,
    color: 'link'
  }, value), /*#__PURE__*/_react.default.createElement(_reactstrap.DropdownMenu, null, values.map((val, index) => {
    return /*#__PURE__*/_react.default.createElement(_reactstrap.DropdownItem, {
      key: index,
      onClick: () => onChange(val),
      active: val === value
    }, val);
  })));
};
class TablePagination extends _react.default.Component {
  render() {
    const {
      children,
      limit,
      limits,
      page,
      total,
      onLimit,
      onFlip,
      onJump,
      ...rest
    } = this.props;
    const prevPage = page > 0;
    const nextPage = page + 1 < Math.ceil(total / limit);
    const numberOfPages = Math.ceil(total / limit);
    let pagesArray = null;
    if (numberOfPages) pagesArray = Array(numberOfPages).fill().map((e, i) => i + 1);
    return /*#__PURE__*/_react.default.createElement("div", null, _react.default.cloneElement(children, rest), /*#__PURE__*/_react.default.createElement("div", {
      className: 'd-flex justify-content-end text-muted'
    }, pagesArray && /*#__PURE__*/_react.default.createElement("div", {
      className: 'mr-5 d-flex align-items-center'
    }, "Page:", /*#__PURE__*/_react.default.createElement(LimitDropdown, {
      onChange: onJump,
      values: pagesArray,
      value: page + 1
    })), /*#__PURE__*/_react.default.createElement("div", {
      className: 'mr-5 d-flex align-items-center'
    }, "Rows per page:", /*#__PURE__*/_react.default.createElement(LimitDropdown, {
      onChange: onLimit,
      values: limits,
      value: limit
    })), /*#__PURE__*/_react.default.createElement("div", {
      className: 'mr-5 d-flex align-items-center'
    }, /*#__PURE__*/_react.default.createElement("span", null, page * limit, "-", page * limit + limit < total ? page * limit + limit : total, " of ", total)), /*#__PURE__*/_react.default.createElement("div", {
      className: 'd-flex align-items-center'
    }, /*#__PURE__*/_react.default.createElement("button", {
      className: 'btn btn-link' + (!prevPage && ' disabled'),
      onClick: () => prevPage ? onFlip(false) : false
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: 'material-icons btn-link'
    }, /*#__PURE__*/_react.default.createElement(_icon.default, {
      icon: "keyboard_arrow_left",
      size: 16
    }))), /*#__PURE__*/_react.default.createElement("button", {
      className: 'btn btn-link' + (!nextPage && ' disabled'),
      onClick: () => nextPage ? onFlip(true) : false
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: 'material-icons btn-link'
    }, /*#__PURE__*/_react.default.createElement(_icon.default, {
      icon: "keyboard_arrow_right",
      size: 16
    }))))));
  }
}
var _default = exports.default = TablePagination;
module.exports = exports.default;